import { Component, OnInit } from '@angular/core';
import { Client } from 'src/app/services/API/client';
import { toastrService } from 'src/app/services/ux/toastr.service';

@Component({
  templateUrl: './code.component.html'
})

export class CodeComponent {
    kodi: any;

    constructor(private client: Client, private toastr: toastrService){
        // this.gjenero();
    }

  ngOnInit() {
  }

  gjenero(){
    this.client.get('api/user/short-uuid')
    .then((res:any) => {
            this.kodi = res.uuid; 
    })
    .catch((error) => {
        this.toastr.warning(error.error);
    });
}
  
}